import { useContext, useEffect, useState } from "react"
import "./index.less"
import { addSensorInstallHistory, getSensorInstallBySensorId } from "@/api/device/sensor"
import { DeviceInstallHistory } from "@/global/interface/device/sensor"
import TnMessage from "@/global/components/message"
import { DatePicker, Form } from "antd"
import TnInput from "@/global/components/input/tn-input"
import TextArea from "rc-textarea"
import { FileUploadParam, UploadFileLocale } from "tncet-common"
import { UploadFileContext } from "@/App"
import { useParams } from "react-router"
import { ProjectFile } from "@/global/interface/project-manage/project-file"
import { uploadProjectFile } from "@/api/project-manage/project-file"
import { getDateDetailName } from "@/global/utils/date-utils"

interface Iprops {
    sensorId: number
}

export default function SensorInstallPanel(props: Iprops) {

    const [installList, setInstallList] = useState<DeviceInstallHistory[]>([])
    const { projectId } = useParams()

    // 是否激活了新增记录按钮
    const [isActiveAddBtn, setIsActiveBtn] = useState<boolean>(false)

    const uploadFileContext = useContext(UploadFileContext);

    const [timeValue, setTimeValue] = useState<number>()
    const [personValue, setPersonValue] = useState<string>()
    const [phoneValue, setPhoneValue] = useState<string>()
    const [objectValue, setObjectValue] = useState<string>()
    const [positionValue, setPositionValue] = useState<string>()

    // 文件上传
    const [uploadFileList, setUploadFileList] = useState([]);
    const [md5Value, setMd5Value] = useState<string>()
    const [file, setFile] = useState<ProjectFile>()

    useEffect(() => {
        generateData()
    }, [props])

    useEffect(() => {
        setTimeValue(null)
        setPersonValue(null)
        setPhoneValue(null)
        setObjectValue(null)
        setPositionValue(null)
        setMd5Value(null)
        setFile(null)
    }, [isActiveAddBtn])

    const generateData = () => {
        if (!props?.sensorId) return
        getSensorInstallBySensorId(props.sensorId).then(res => {
            let list: DeviceInstallHistory[] = res?.data || []
            list.sort((a, b) => b.installTime - a.installTime)
            setInstallList(list)
        }).catch(() => {
            TnMessage.error("获取 安装/更换 数据失败！")
        })
    }

    const handleFileChange = (e) => {
        const newFileList = Array.from(e.target.files);
        beforeUpload(null, newFileList);
    };

    const beforeUpload = (file, fileList) => {
        if (uploadFileList.length === 0) {
            setUploadFileList([...fileList]);
        }
        return false;
    }

    useEffect(() => {
        if (!uploadFileContext.visible && uploadFileList.length > 0) {
            setUploadFileList([]);
        }
    }, [uploadFileContext.visible])

    useEffect(() => {
        if (uploadFileList.length === 0) return;
        let files: UploadFileLocale[] = uploadFileList.map(item => {
            return {
                file: item,
                callbackFn: uploadCallbackFn
            }
        })
        uploadFileContext.startUpload(files)
    }, [uploadFileList])

    const uploadCallbackFn = (uploadFile: FileUploadParam) => {
        return new Promise(resolve => {
            let data: ProjectFile = {
                ...uploadFile,
                projectId: +projectId,
            }
            setFile(data)
            setMd5Value(data.md5)
            resolve(true)
        })
    }

    const addInstall = () => {
        let addValue: DeviceInstallHistory = {
            installTime: timeValue,
            installPerson: personValue,
            phone: phoneValue,
            installObject: objectValue,
            position: positionValue,
            md5: md5Value,
            file: file
        }
        addSensorInstallHistory(Number(projectId), props.sensorId, addValue).then(res => {
            generateData()
            setIsActiveBtn(false)
        }).catch(e => {
            TnMessage.error("添加失败！")
        })
    }

    return (
        <div className="install-main">
            <div className="title">
                安装/更换
                {!isActiveAddBtn && (
                    <div className="add-btn" onClick={() => { setIsActiveBtn(true) }}>
                        新增记录
                    </div>
                )}
            </div>
            <div className="install-list">
                {installList?.map((item, index) => (
                    <div className="install-item">
                        <div className="picture">
                            {item?.url && (
                                <img width={640} height={360} src={item.url} />
                            )}
                        </div>
                        <div className="detail-list">
                            <div className="item">
                                <div className="title">
                                    安装时间
                                </div>
                                <div className="value">
                                    {getDateDetailName(item.installTime)}
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    安装人员
                                </div>
                                <div className="value">
                                    {item?.installPerson || ""}
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    电话
                                </div>
                                <div className="value">
                                    {item?.phone || ""}
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    对象
                                </div>
                                <div className="value">
                                    {item?.installObject || ""}
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    方位
                                </div>
                                <div className="value-area">
                                    {item?.position}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {isActiveAddBtn && (
                    <div className="install-item">
                        <div className="picture">
                            <input type="file" onChange={handleFileChange} multiple accept="image/*" />
                        </div>
                        <div className="detail-list">
                            <div className="item">
                                <div className="title">
                                    安装时间
                                </div>
                                <div className="value">
                                    <DatePicker onChange={(e) => {
                                        setTimeValue(e.valueOf())
                                    }} />
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    安装人员
                                </div>
                                <div className="value">
                                    <TnInput value={personValue} onTextChange={setPersonValue} />
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    电话
                                </div>
                                <div className="value">
                                    <TnInput value={phoneValue} onTextChange={setPhoneValue} />
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    对象
                                </div>
                                <div className="value">
                                    <TnInput value={objectValue} onTextChange={setObjectValue} />
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    方位
                                </div>
                                <div className="value-area">
                                    <TextArea className="text-area" value={positionValue} onChange={(e) => {
                                        setPositionValue(e.target.value)
                                    }} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
            {isActiveAddBtn && (
                <div className="down-btn-area">
                    <div className="cancel-btn" onClick={() => { setIsActiveBtn(false) }}>
                        取消
                    </div>
                    <div className="save-btn" onClick={() => { addInstall() }}>
                        提交
                    </div>
                </div>
            )}
        </div>
    )
}